import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import decode from "jwt-decode";

import search from "../../assets/search-solid.svg";
import Avatar from "../../components/Avatar/Avatar";
import "./Navbar.css";
import { setCurrentUser } from "../../actions/currentUser";
import bars from "../../assets/bars-solid.svg";

const Navbar = ({ handleSlideIn }) => {
  const dispatch = useDispatch();
  const User = useSelector((state) => state.currentUserReducer);
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch({ type: "LOGOUT" });
    navigate("/");
    dispatch(setCurrentUser(null));
  };

  useEffect(() => {
    const token = User?.token;

    if (token) {
      const decodedToken = decode(token);
      if (decodedToken.exp * 1000 < new Date().getTime()) {
        handleLogout();
      }
    }

    dispatch(setCurrentUser(JSON.parse(localStorage.getItem("Profile"))));
  }, [User?.token, dispatch]);

  return (
    <nav className="main-nav">
      <div className="navbar">
        {/* LEFT */}
        <div className="navbar-left">
          <button className="slide-in-icon" onClick={handleSlideIn}>
            <img src={bars} alt="menu" width="16" />
          </button>

          <Link to="/" className="brand">
            <span className="brand-dev">Dev</span>
            <span className="brand-q">Q</span>
          </Link>
        </div>

        {/* CENTER */}
        <div className="navbar-center">
          <Link to="/" className="nav-item res-nav">
            Explore
          </Link>
          <Link to="/" className="nav-item res-nav">
            Community
          </Link>
          <Link to="/" className="nav-item res-nav">
            Developers
          </Link>

          <form>
            <input type="text" placeholder="Search..." />
            <img src={search} alt="search" className="search-icon" />
          </form>
        </div>

        {/* RIGHT */}
        <div className="navbar-right">
          {User === null ? (
            <Link to="/Auth" className="login-btn">
              Log in
            </Link>
          ) : (
            <div className="user-box">
              <Link to={`/Users/${User?.result?._id}`} className="avatar-link">
                <Avatar
                  backgroundColor="#38bdf8"
                  px="10px"
                  py="7px"
                  borderRadius="50%"
                  color="white"
                >
                  {User.result.name.charAt(0).toUpperCase()}
                </Avatar>
              </Link>

              <button className="logout-btn" onClick={handleLogout}>
                Log out
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
